import React from "react";
import "./popover_comp.scss";
import { Popover } from "antd";

function PopoverComp({
  children,
  content,
  title,
  open,
  setOpen,
  placement = "bottomRight",
}) {
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <Popover
      onOpenChange={handleOpenChange}
      placement={placement}
      open={open}
      trigger="click"
      content={content}
      rootClassName="popover-comp"
      arrow={false}
      title={title}
    >
      {children}
    </Popover>
  );
}

export default PopoverComp;
